/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import {
    FormValidationAlert,
    Heading,
    Notification,
    Stack,
    useFlags,
} from 'sarsaparilla';
import PropTypes from 'prop-types';

export default function Header({ errors }) {
    const { iaPassesGovShutdown } = useFlags();

    return (
        <div className="ia-header">
            <Stack space="xs">
                <Heading headingLevel={1} appearance="h3" className="ia-header-title">
                    Pass Selection
                </Heading>
                <Heading headingLevel={2} appearance="h6" className="ia-header-subtitle">
                    Interagency Annual Pass
                </Heading>
                <FormValidationAlert className="ia-header-errors" errors={errors} />
                <div className="ia-header-description">
                    <p>
                        Enter the number of passes you would like to purchase below (max
                        of 5).
                    </p>
                </div>
                {iaPassesGovShutdown && (
                    <Notification
                        type="warning"
                        title="Lapse in Funding"
                        headingLevel={3}
                        className="ia-header-notification"
                        hasSolidBackground
                    >
                        <p>
                            Interagency Pass sales are not available during the lapse in
                            funding. We will resume pass sales after government operations
                            have resumed.
                        </p>
                    </Notification>
                )}
            </Stack>
        </div>
    );
}

Header.propTypes = {
    errors: PropTypes.object.isRequired,
};
